
import { ValueMetricsSection as GenericValueMetricsSection } from "@/components/services/specializations/ValueMetricsSection";

export const ValueMetricsSection = () => {
  // Value metrics data
  const valueMetrics = [
    {
      value: "157%",
      label: "Average ROI",
      description: "For organizations that fully leverage their Microsoft 365 security features"
    },
    {
      value: "65%",
      label: "Reduction in Incidents",
      description: "Achieved by properly configuring built-in security controls"
    },
    {
      value: "40%",
      label: "Cost Savings",
      description: "By eliminating redundant third-party security solutions"
    },
    {
      value: "85%",
      label: "Security Controls",
      description: "Most organizations utilize less than half of available security controls"
    }
  ];

  return (
    <GenericValueMetricsSection 
      title="Maximize Your Microsoft 365 Investment"
      subtitle="Untapped Value"
      description="Most organizations use less than 40% of their Microsoft 365 security capabilities. We help you unlock the full potential of what you already own."
      metrics={valueMetrics}
    />
  );
};
